module.exports = __webpack_public_path__ + "img/FR16588.dd54f59c.svg";